var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLowValueIcon = function SvgLowValueIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.295 147.255",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lowValueIcon_svg__a{fill:#fff}.lowValueIcon_svg__c{fill:#275fe0}.lowValueIcon_svg__e{fill:#407bff}.lowValueIcon_svg__f{opacity:.3}.lowValueIcon_svg__h{fill:#263238}.lowValueIcon_svg__k{fill:#4e7be3}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.097 51.227)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 22,
    className: "lowValueIcon_svg__a",
    rx: 22.5,
    ry: 22,
    transform: "translate(-.097 -.329)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1a21.8 21.8 0 0 0-8.376 1.653 21.5 21.5 0 0 0-6.835 4.506 20.9 20.9 0 0 0-4.6 6.675 20.62 20.62 0 0 0 0 16.333 20.9 20.9 0 0 0 4.6 6.675 21.5 21.5 0 0 0 6.835 4.506 22.05 22.05 0 0 0 16.752 0 21.5 21.5 0 0 0 6.835-4.506 20.9 20.9 0 0 0 4.6-6.675 20.62 20.62 0 0 0 0-16.333 20.9 20.9 0 0 0-4.6-6.675 21.5 21.5 0 0 0-6.835-4.506A21.8 21.8 0 0 0 22.5 1m0-1A22.254 22.254 0 0 1 45 22a22.254 22.254 0 0 1-22.5 22A22.254 22.254 0 0 1 0 22 22.254 22.254 0 0 1 22.5 0",
    style: {
      fill: "#dee2ed"
    },
    transform: "translate(-.097 -.329)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.196 25.264a6 6 0 0 0 1.695 3.537 4.96 4.96 0 0 0 3.438 1.135 9.66 9.66 0 0 0 4.7-1.382v3.356a14 14 0 0 1-2.533.938 10.6 10.6 0 0 1-2.628.312 8.7 8.7 0 0 1-5.971-2.04 10 10 0 0 1-3.044-5.856h-2.829l.592-2.369h2.139v-2.632h-2.731l.592-2.4h2.3a10.36 10.36 0 0 1 3.326-5.693A8.68 8.68 0 0 1 25 10.13a10.8 10.8 0 0 1 6.152 1.875l-1.546 2.665a8.7 8.7 0 0 0-2.139-1.036 7.9 7.9 0 0 0-2.3-.313 4.44 4.44 0 0 0-3.046 1.119 6.64 6.64 0 0 0-1.859 3.422h8.192l-.625 2.4h-7.764v2.632h7.209l-.564 2.37Z",
    className: "lowValueIcon_svg__c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m90.158 50.49 13.848 18.846L117.85 50.49h-8.435A50.55 50.55 0 0 0 58.925 0v10.819A39.716 39.716 0 0 1 98.6 50.49ZM13.844 31.652l13.848 18.842h-8.439a39.72 39.72 0 0 0 39.672 39.668v10.818a50.54 50.54 0 0 1-50.49-50.486H0Z",
    style: {
      fill: "#b3c9fe"
    },
    transform: "rotate(149 64.51 64.497)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.326 85.16a5.758 5.758 0 0 1 5.815-6.972h-28.12a5.756 5.756 0 0 0-5.81 6.972Z",
    className: "lowValueIcon_svg__e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.326 85.16a5.758 5.758 0 0 1 5.815-6.972h-28.12a5.756 5.756 0 0 0-5.81 6.972Z",
    className: "lowValueIcon_svg__f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.141 78.188h-28.12a8.56 8.56 0 0 1 8.13 6.972l6.155 37.177a8.57 8.57 0 0 0 8.13 6.972h14.183a5.758 5.758 0 0 0 5.815-6.972l-6.163-37.177a8.56 8.56 0 0 0-8.13-6.972",
    className: "lowValueIcon_svg__c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.253 122.359a5.758 5.758 0 0 1-5.815 6.972h28.12a5.752 5.752 0 0 0 5.815-6.972Z",
    className: "lowValueIcon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.207 49.713a5.758 5.758 0 0 1-5.815 6.972h28.12a5.752 5.752 0 0 0 5.815-6.972Z",
    style: {
      opacity: 0.3,
      fill: "#a4bbdb"
    },
    transform: "translate(103.046 72.646)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.777 88.389h-20.069a.516.516 0 0 1-.488-.418.342.342 0 0 1 .349-.418h20.069a.516.516 0 0 1 .488.418.342.342 0 0 1-.349.418M129.657 91.293h-8.472a.516.516 0 0 1-.488-.418.342.342 0 0 1 .349-.418h8.471a.516.516 0 0 1 .488.418.35.35 0 0 1-.349.418ZM137.493 91.293h-5.856a.51.51 0 0 1-.481-.418.342.342 0 0 1 .342-.418h5.857a.51.51 0 0 1 .481.418.342.342 0 0 1-.342.418ZM141.768 94.225h-20.1a.51.51 0 0 1-.488-.411.34.34 0 0 1 .349-.418H141.6a.516.516 0 0 1 .488.418.342.342 0 0 1-.321.411ZM140.241 97.097h-18.094a.516.516 0 0 1-.488-.418.35.35 0 0 1 .349-.418h18.128a.516.516 0 0 1 .488.418.35.35 0 0 1-.383.418M134.795 99.997h-12.166a.516.516 0 0 1-.488-.418.342.342 0 0 1 .349-.411h12.173a.52.52 0 0 1 .488.411.35.35 0 0 1-.356.418M143.162 102.905H123.11a.516.516 0 0 1-.488-.418.35.35 0 0 1 .349-.418h20.073a.516.516 0 0 1 .488.418.342.342 0 0 1-.37.418M143.664 105.806H123.59a.516.516 0 0 1-.488-.418.35.35 0 0 1 .349-.418h20.08a.51.51 0 0 1 .481.418.342.342 0 0 1-.349.418ZM136.245 108.706h-12.174a.52.52 0 0 1-.488-.411.35.35 0 0 1 .349-.418h12.174a.516.516 0 0 1 .488.418.342.342 0 0 1-.349.411",
    className: "lowValueIcon_svg__a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m147.77 116.689 1.256.779 19.269-31.066-1.256-.779Z",
    className: "lowValueIcon_svg__h"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m147.77 116.689 1.256.779 19.269-31.066-1.256-.779Z",
    className: "lowValueIcon_svg__f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m145.263 115.136 1.256.779 19.269-31.065-1.253-.779Z",
    className: "lowValueIcon_svg__h"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m145.263 115.136 1.256.779 19.269-31.065-1.253-.779Z",
    className: "lowValueIcon_svg__f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m146.525 115.908 1.256.779 19.27-31.063-1.256-.779Z",
    className: "lowValueIcon_svg__h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m41.7 45.719 1.13.7 2.67-1.36-3.765-2.336Z",
    style: {
      fill: "#ff8b7b"
    },
    transform: "translate(103.534 72.407)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m145.219 119.416 1.144-.586-1.13-.7Z",
    className: "lowValueIcon_svg__h"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.557 119.673h-.049a6.2 6.2 0 0 1-2.405-1.771 10.5 10.5 0 0 0-1.318-1.192.4.4 0 0 0-.509 0 .335.335 0 0 0 0 .453 6 6 0 0 0 .544.7.52.52 0 0 1 .063.621.48.48 0 0 1-.551.174 8 8 0 0 1-.781-.3.119.119 0 0 0-.167.167l.035.091a.58.58 0 0 1-.056.572.59.59 0 0 1-.516.23 91 91 0 0 0-9.211.035.174.174 0 0 1 0-.349 91 91 0 0 1 9.245-.035.22.22 0 0 0 .209-.084.24.24 0 0 0 0-.237l-.035-.077a.467.467 0 0 1 .635-.635 5.6 5.6 0 0 0 .739.286.13.13 0 0 0 .153 0 .17.17 0 0 0-.035-.2c-.2-.237-.39-.488-.565-.739a.67.67 0 0 1 .99-.9 10 10 0 0 1 1.395 1.234 6 6 0 0 0 2.189 1.611.186.186 0 0 1 0 .349Z",
    className: "lowValueIcon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30.379v52.473H0z",
    style: {
      fill: "#d9e4fe"
    },
    transform: "translate(9.124 18.317)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.529 12.794H11.262a3.99 3.99 0 0 0-3.979 3.98V67.73a3.99 3.99 0 0 0 3.979 3.981h26.267a3.99 3.99 0 0 0 3.979-3.979V16.774a3.99 3.99 0 0 0-3.979-3.98m-17.335 2.869h8.4a.483.483 0 0 1 0 .965h-8.4a.483.483 0 0 1 0-.965m4.2 54.059a1.991 1.991 0 1 1 1.99-1.991 1.99 1.99 0 0 1-1.988 1.991Zm14.344-5.375H10.052V19.105H38.74Z",
    className: "lowValueIcon_svg__c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.806 22.92h.957v4.784h-.957z",
    className: "lowValueIcon_svg__k"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.591 22.92v.957h-4.784v-.957zM35.827 22.92v.957h-4.784v-.957z",
    className: "lowValueIcon_svg__k"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.827 27.705h-.957v-4.784h.957zM35.827 61.082h-.957v-4.784h.957z",
    className: "lowValueIcon_svg__k"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.043 61.082v-.957h4.784v.957zM12.806 61.082v-.957h4.784v.957z",
    className: "lowValueIcon_svg__k"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.806 56.298h.957v4.784h-.957z",
    className: "lowValueIcon_svg__k"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLowValueIcon);
export default ForwardRef;